// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store'; // Import the store

// ignore uncaught errors, unhandled rejections from browser extensions
const isFromExtension = (source) =>
  typeof source === 'string' && source.indexOf('chrome-extension://') !== -1;

window.addEventListener('error', (event) => {
  if (isFromExtension(event.filename)) {
    event.preventDefault();
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const stack = reason?.stack ?? '';
  const message = typeof reason?.message === 'string' ? reason.message : String(reason);
  const fromExtension =
    isFromExtension(stack) || stack.indexOf('chrome-extension://') !== -1 || /MetaMask|ethereum/i.test(message);
  if (fromExtension) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

reportWebVitals();